import React, { useState, useEffect } from 'react';

import Footer from '../components/footer/index';
import { useDarkMode } from '../components/darkmode/DarkModeContext';
import ProdukCCTV from '../components/CCTV/produkCCTV';
import SecurityUpgradeSection from '../components/CCTV/tombol';

const CCTVPage = () => {
  const { isDarkMode } = useDarkMode();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [activeTab, setActiveTab] = useState('semua');
  const [showComparison, setShowComparison] = useState(false);
  const [promoTimeLeft, setPromoTimeLeft] = useState({
    days: 3,
    hours: 12,
    minutes: 45,
    seconds: 30
  });

  const cctvPackages = [
    {
      id: 'home-cctv',
      category: 'rumah',
      cameras: '2-4 Kamera',
      name: 'Paket CCTV Rumah',
      description: 'Paket instalasi CCTV dengan kamera kualitas tinggi untuk pemantauan rumah pribadi',
      price: 'Rp 2.499.000',
      originalPrice: 'Rp 3.199.000',
      discount: '22%',
      badge: 'POPULER',
      badgeColor: 'bg-green-600',
      popular: true,
      features: [
        { name: '2-4 Kamera HD', icon: '📹' },
        { name: 'Penyimpanan Cloud 7 hari', icon: '☁️' },
        { name: 'Akses Mobile App', icon: '📱' },
        { name: 'Night Vision', icon: '🌙' },
        { name: 'Instalasi Profesional', icon: '🔧' },
        { name: 'Garansi 1 Tahun', icon: '🔖' }
      ],
      cameras_detail: {
        'Indoor': 2,
        'Outdoor': 2,
        'Resolusi': '1080p HD',
        'Infrared': '20m',
        'Weatherproof': 'IP66'
      },
      ideal: ['Rumah tinggal', 'Apartemen', 'Pemantauan keluarga', 'Keamanan properti'],
      storage: 'Cloud 7 hari',
      support: '24/7'
    },
    {
      id: 'business-cctv',
      category: 'bisnis',
      cameras: '4-8 Kamera',
      name: 'Paket CCTV Bisnis',
      description: 'Paket lengkap untuk bisnis dengan beberapa kamera pengawasan dan penyimpanan data besar',
      price: 'Rp 4.999.000',
      originalPrice: 'Rp 6.499.000',
      discount: '23%',
      badge: 'REKOMENDASI',
      badgeColor: 'bg-orange-600',
      popular: false,
      features: [
        { name: '4-8 Kamera 4K', icon: '📹' },
        { name: 'Penyimpanan Cloud 30 hari', icon: '☁️' },
        { name: 'Akses Multi-User', icon: '👥' },
        { name: 'PTZ Control', icon: '🎮' },
        { name: 'Motion Detection', icon: '🚨' },
        { name: 'Monitor Included', icon: '🖥️' },
        { name: 'Remote Access', icon: '🌐' },
        { name: 'Garansi 2 Tahun', icon: '🔖' }
      ],
      cameras_detail: {
        'Indoor': 4,
        'Outdoor': 4,
        'Resolusi': '4K Ultra HD',
        'PTZ': 'Ya',
        'Infrared': '30m',
        'Weatherproof': 'IP67'
      },
      ideal: ['Toko retail', 'Restoran', 'Kantor kecil', 'Showroom'],
      storage: 'Cloud 30 hari',
      support: 'Priority 24/7'
    },
    {
      id: 'enterprise-cctv',
      category: 'perusahaan',
      cameras: '8+ Kamera',
      name: 'Paket CCTV Perusahaan',
      description: 'Layanan untuk perusahaan besar dengan perangkat CCTV canggih dan multi-lokasi',
      price: 'Rp 8.999.000',
      originalPrice: 'Rp 11.999.000',
      discount: '25%',
      badge: 'ENTERPRISE',
      badgeColor: 'bg-green-700',
      popular: false,
      features: [
        { name: '8+ Kamera 4K/8K', icon: '📹' },
        { name: 'Penyimpanan Cloud 90 hari', icon: '☁️' },
        { name: 'Kamera PTZ Canggih', icon: '🎥' },
        { name: 'Analytics AI', icon: '🤖' },
        { name: 'Multi-Location Access', icon: '🏢' },
        { name: 'Dedicated NVR', icon: '💾' },
        { name: 'Advanced Encryption', icon: '🔒' },
        { name: '24/7 Monitoring', icon: '👁️' },
        { name: 'Garansi 3 Tahun', icon: '🔖' }
      ],
      cameras_detail: {
        'Indoor': 6,
        'Outdoor': 6,
        'PTZ': 2,
        'Resolusi': '4K/8K',
        'Infrared': '50m',
        'Weatherproof': 'IP68',
        'AI Features': 'Ya'
      },
      ideal: ['Perusahaan besar', 'Pabrik', 'Gudang', 'Multi-lokasi'],
      storage: 'Cloud 90 hari + NVR',
      support: 'Dedicated 24/7'
    }
  ];

  const cameraFeatures = [
    {
      title: 'Kamera HD & 4K',
      description: 'Kualitas gambar tinggi 1080p HD, 4K, atau 8K untuk pengawasan tajam dan jelas',
      icon: 'image/CCTV/kamera.png',
      color: 'from-green-600 to-emerald-600'
    },
    {
      title: 'Infrared Night Vision',
      description: 'Pengawasan di malam hari atau kondisi cahaya rendah dengan teknologi IR',
      icon: 'image/CCTV/infrared.png',
      color: 'from-green-600 to-green-700'
    },
    {
      title: 'Kamera PTZ',
      description: 'Kamera yang bisa bergerak (pan, tilt, zoom) secara otomatis atau manual',
      icon: 'image/CCTV/kamerafirtz.png',
      color: 'from-green-600 to-emerald-600'
    },
    {
      title: 'Outdoor & Indoor',
      description: 'Kamera untuk indoor dan outdoor dengan perlindungan cuaca (IP66, IP67)',
      icon: 'image/CCTV/indoor&outdoor.png',
      color: 'from-green-700 to-green-800'
    },
    {
      title: 'Kamera WiFi',
      description: 'Kamera yang terhubung langsung ke jaringan Wi-Fi tanpa kabel tambahan',
      icon: 'image/CCTV/kamerawifi.png',
      color: 'from-emerald-600 to-green-600'
    },
    {
      title: 'Akses Jarak Jauh',
      description: 'Akses video CCTV melalui aplikasi mobile atau website dari mana saja',
      icon: 'image/CCTV/jarakjauh.png',
      color: 'from-green-600 to-green-700'
    }
  ];

  const promoOffers = [
    {
      title: 'Gratis Konsultasi',
      description: 'Konsultasi gratis dengan ahli keamanan untuk solusi terbaik',
      icon: 'image/CCTV/konsultasi.png',
      color: 'from-green-600 to-emerald-600'
    },
    {
      title: 'Instalasi Gratis',
      description: 'Gratis instalasi profesional untuk pembelian paket tertentu',
      icon: 'image/CCTV/instalasi.png',
      color: 'from-green-600 to-emerald-600'
    },
    {
      title: 'Extended Warranty',
      description: 'Tambahan 1 tahun garansi untuk pembelian bulan ini',
      icon: 'image/CCTV/extended.png',
      color: 'from-green-600 to-green-700'
    },
    {
      title: 'Cloud Storage Bonus',
      description: 'Bonus 30 hari tambahan cloud storage',
      icon: 'image/CCTV/cloud.png',
      color: 'from-green-700 to-green-800'
    }
  ];

  const comparisonFeatures = [
    'Jumlah Kamera',
    'Resolusi Kamera',
    'Penyimpanan',
    'Night Vision',
    'Akses Mobile',
    'PTZ Control',
    'Weatherproof',
    'Garansi',
    'Support'
  ];

  // Promo countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setPromoTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  const filteredPackages = activeTab === 'semua' ? cctvPackages : cctvPackages.filter(pkg => pkg.category === activeTab);

  const getComparisonValue = (pkg, feature) => {
    switch (feature) {
      case 'Jumlah Kamera': return pkg.cameras;
      case 'Resolusi Kamera': return pkg.cameras_detail.Resolusi;
      case 'Penyimpanan': return pkg.storage;
      case 'Night Vision': return pkg.cameras_detail.Infrared ? pkg.cameras_detail.Infrared : '❌';
      case 'Akses Mobile': return pkg.features.some(f => f.name.includes('Mobile')) ? '✅' : '❌';
      case 'PTZ Control': return pkg.cameras_detail.PTZ || pkg.features.some(f => f.name.includes('PTZ')) ? '✅' : '❌';
      case 'Weatherproof': return pkg.cameras_detail.Weatherproof || '❌';
      case 'Garansi': return pkg.features.find(f => f.name.includes('Garansi'))?.name || '-';
      case 'Support': return pkg.support;
      default: return '-';
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDarkMode ? 'bg-gray-900 text-green-50' : 'bg-white text-gray-900'}`}>
      <style>
        {`
          .hero-gradient {
            background: ${isDarkMode 
              ? 'linear-gradient(135deg, #111827 0%, #1E9B4C 50%, #22c55e 100%)' 
              : 'linear-gradient(135deg, #dfe4e0 0%, #1E9B4C 50%, #16a34a 100%)'
            };
          }
          
          .package-card {
            transition: all 0.3s ease;
            background: ${isDarkMode 
              ? 'linear-gradient(145deg, #1f2937, #111827)' 
              : 'linear-gradient(145deg, #ffffff, #f8fafc)'
            };
          }
          
          .package-card:hover {
            transform: translateY(-10px);
            box-shadow: ${isDarkMode 
              ? '0 25px 50px -12px rgba(34, 197, 94, 0.4)' 
              : '0 25px 50px -12px rgba(30, 155, 76, 0.4)'
            };
          }
          
          .package-card.popular {
            border: 2px solid ${isDarkMode ? '#22c55e' : '#1E9B4C'};
            position: relative;
          }
          
          .package-card.popular::before {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, #1E9B4C, #22c55e, #1E9B4C);
            border-radius: inherit;
            z-index: -1;
            animation: borderGlow 3s ease-in-out infinite;
          }
          
          @keyframes borderGlow {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          .feature-icon {
            background: linear-gradient(135deg, #1E9B4C, #22c55e);
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
          }
          
          .promo-card {
            transition: all 0.3s ease;
          }
          
          .promo-card:hover {
            transform: translateY(-5px);
          }
          
          .comparison-table {
            background: ${isDarkMode 
              ? 'linear-gradient(145deg, #1f2937, #111827)' 
              : 'linear-gradient(145deg, #ffffff, #f8fafc)'
            };
          }
          
          .tab-button.active {
            background: linear-gradient(135deg, #1E9B4C, #22c55e);
          }
          
          .countdown-item {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
          
          .glass-effect {
            background: ${isDarkMode 
              ? 'rgba(255, 255, 255, 0.1)' 
              : 'rgba(30, 155, 76, 0.1)'
            };
            backdrop-filter: blur(10px);
            border: 1px solid ${isDarkMode 
              ? 'rgba(255, 255, 255, 0.2)' 
              : 'rgba(30, 155, 76, 0.2)'
            };
          }
          
          .pulse-animation {
            animation: pulse 2s infinite;
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          
          .cctv-floating {
            animation: float 6s ease-in-out infinite;
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
        `}
      </style>
      
      
      
      {/* Hero Section */}
      <section 
        className="relative overflow-hidden min-h-screen flex items-center bg-cover bg-center"
        style={{ 
          backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0',
          backgroundBlendMode: 'overlay'
        }}
      >
        <video 
    autoPlay 
    loop 
    muted 
    className="absolute inset-0 w-full h-full object-cover z-0"
  >
    <source src="image/bannerCCTV.mp4" type="video/mp4" />
    {/* You can also add a fallback image for browsers that don't support video */}
    <img src="https://telnet.net.id/assets/bg.png" alt="Background" className="w-full h-full object-cover" />
  </video>
        {/* Background overlay */}
        <div className={`absolute inset-0 z-0 ${
          isDarkMode 
            ? 'bg-gradient-to-r from-black/80 via-green-900/60 to-black/80' 
            : 'bg-gradient-to-r from-white/70 via-green-100/60 to-white/70'
        }`}></div>

        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto px-4 text-center w-full">
          <div className="mb-8">
            <h1 className={`text-5xl md:text-7xl font-bold mb-6 leading-tight transition-colors duration-300 ${
              isDarkMode ? 'text-green-50' : 'text-gray-900'
            }`}>
              Sistem <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-400">CCTV</span> Profesional
            </h1>
            <p className={`text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              Lindungi properti Anda dengan sistem CCTV canggih berkualitas tinggi. Pantau rumah, bisnis, atau perusahaan Anda dari mana saja secara real-time.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            {/* <button 
              onClick={() => document.getElementById('packages').scrollIntoView({ behavior: 'smooth' })}
              className={`px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 pulse-animation shadow-2xl ${
                isDarkMode 
                  ? 'bg-green-600 text-white hover:bg-green-700' 
                  : 'bg-white text-green-600 hover:bg-gray-100'
              }`}
            >
              Dapatkan Penawaran
            </button> */}
          </div>
        </div>
      </section>

      {/* Promo & Offers Section */}
      <section className={`py-16 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gray-50'
      }`}
        style={{ 
          backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0',
          backgroundBlendMode: 'overlay'
        }}
      >
        <div className="max-w-8xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className={`text-4xl font-bold mb-4 transition-colors duration-300 ${
              isDarkMode ? 'text-green-50' : 'text-gray-900'
            }`}>
              Penawaran Spesial CCTV
            </h2>
            <p className={`text-xl max-w-2xl mx-auto transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              Dapatkan solusi keamanan terbaik dengan penawaran spesial kami
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {promoOffers.map((offer, index) => (
            <div key={index} className={`promo-card bg-white rounded-2xl p-6 text-blanck`}>
              <div className="mb-4">
                <img src={offer.icon} alt={offer.title} className="w-38 h-38 object-contain" />
              </div>
              <h3 className="text-xl font-bold mb-2">{offer.title}</h3>
              <p className="text-black-100">{offer.description}</p>
            </div>
          ))}
        </div>
        </div>
      </section>

      <ProdukCCTV />

      {/* Package Comparison Table */}
      {showComparison && (
        <section className={`py-16 transition-colors duration-300 ${
          isDarkMode ? 'bg-gray-800' : 'bg-gray-50'
        }`}>
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-8">
              <h2 className={`text-3xl font-bold mb-4 transition-colors duration-300 ${
                isDarkMode ? 'text-green-50' : 'text-gray-900'
              }`}>
                Perbandingan Paket CCTV
              </h2>
              <p className={`transition-colors duration-300 ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}>
                Bandingkan fitur dan spesifikasi dari semua paket dalam satu tabel
              </p>
            </div>

            <div className="comparison-table rounded-2xl overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-green-600">
                      <th className="p-4 text-left font-semibold text-white">Fitur</th>
                      {cctvPackages.map(pkg => (
                        <th key={pkg.id} className="p-4 text-center font-semibold min-w-[200px] text-white">
                          <div>{pkg.name}</div>
                          <div className="text-sm font-normal text-green-200">{pkg.cameras}</div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {comparisonFeatures.map((feature, index) => (
                      <tr key={feature} className={`transition-colors duration-300 ${
                        index % 2 === 0 
                          ? isDarkMode ? 'bg-gray-750' : 'bg-gray-100'
                          : isDarkMode ? 'bg-gray-700' : 'bg-white'
                      }`}>
                        <td className={`p-4 font-semibold transition-colors duration-300 ${
                          isDarkMode ? 'text-gray-300' : 'text-gray-700'
                        }`}>
                          {feature}
                        </td>
                        {cctvPackages.map(pkg => (
                          <td key={pkg.id} className={`p-4 text-center transition-colors duration-300 ${
                            isDarkMode ? 'text-gray-200' : 'text-gray-800'
                          }`}>
                            {getComparisonValue(pkg, feature)}
                          </td>
                        ))}
                      </tr>
                    ))}
                    <tr className="bg-green-600">
                      <td className="p-4 font-semibold text-white">Harga/Paket</td>
                      {cctvPackages.map(pkg => (
                        <td key={pkg.id} className="p-4 text-center text-white">
                          <div className="font-bold text-lg">{pkg.price}</div>
                          {pkg.originalPrice && (
                            <div className="text-sm text-green-200 line-through">{pkg.originalPrice}</div>
                          )}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="text-center mt-8">
              <button 
                onClick={() => setShowComparison(false)}
                className={`px-6 py-3 rounded-xl font-semibold transition-colors ${
                  isDarkMode 
                    ? 'bg-gray-700 hover:bg-gray-600 text-white' 
                    : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                }`}
              >
                Tutup Perbandingan
              </button>
            </div>
          </div>
        </section>
      )}

      {/* Camera Features Section */}
      <section className={`py-16 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gray-50'
      }`}
      style={{ 
          backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0',
          backgroundBlendMode: 'overlay'
        }}
      >
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className={`text-4xl font-bold mb-4 transition-colors duration-300 ${
              isDarkMode ? 'text-green-50' : 'text-gray-900'
            }`}>
              Fitur Kamera CCTV
            </h2>
            <p className={`text-xl max-w-3xl mx-auto transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              Teknologi canggih untuk sistem pengawasan yang andal dan efektif
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
           {cameraFeatures.map((feature, index) => (
            <div key={index} className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all ${
              isDarkMode ? 'bg-gray-700' : 'bg-white shadow-md'
            }`}>
              {/* Ganti div.icon dengan img */}
              <img src={feature.icon} alt={feature.title} className="text-5xl mb-4 w-24 h-24 mx-auto" />
              
              <h3 className={`text-xl font-bold mb-3 transition-colors duration-300 ${
                isDarkMode ? 'text-green-50' : 'text-gray-900'
              }`}>
                {feature.title}
              </h3>
              <p className={`transition-colors duration-300 ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}>
                {feature.description}
              </p>
            </div>
          ))}
          </div>
        </div>
      </section>

      {/* Package Detail Modal */}
      {selectedPackage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className={`rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto transition-colors duration-300 ${
            isDarkMode ? 'bg-gray-800' : 'bg-white'
          }`}>
            <div className="p-6">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h2 className={`text-2xl font-bold mb-2 transition-colors duration-300 ${
                    isDarkMode ? 'text-green-50' : 'text-gray-900'
                  }`}>
                    {selectedPackage.name}
                  </h2>
                  <div className="text-green-600 text-lg font-semibold">{selectedPackage.cameras}</div>
                </div>
                <button 
                  onClick={() => setSelectedPackage(null)}
                  className={`text-2xl transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  ×
                </button>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Left Column */}
                <div className="space-y-6">
                  {/* Price */}
                  <div className={`rounded-xl p-4 transition-colors duration-300 ${
                    isDarkMode ? 'bg-gray-700' : 'bg-gray-50'
                  }`}>
                    <div className="flex items-baseline gap-2 mb-2">
                      <span className={`text-3xl font-bold transition-colors duration-300 ${
                        isDarkMode ? 'text-green-50' : 'text-gray-900'
                      }`}>
                        {selectedPackage.price}
                      </span>
                      {selectedPackage.originalPrice && (
                        <>
                          <span className={`text-xl line-through transition-colors duration-300 ${
                            isDarkMode ? 'text-gray-400' : 'text-gray-500'
                          }`}>
                            {selectedPackage.originalPrice}
                          </span>
                          <span className="bg-red-500 text-white px-2 py-1 rounded-full text-sm font-bold">
                            -{selectedPackage.discount}
                          </span>
                        </>
                      )}
                    </div>
                    <div className={`transition-colors duration-300 ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-600'
                    }`}>
                      per paket
                    </div>
                  </div>

                  {/* All Features */}
                  <div>
                    <h3 className={`text-lg font-semibold mb-4 transition-colors duration-300 ${
                      isDarkMode ? 'text-green-50' : 'text-gray-900'
                    }`}>
                      Semua Fitur & Keunggulan
                    </h3>
                    <div className="space-y-3">
                      {selectedPackage.features.map((feature, i) => (
                        <div key={i} className="flex items-center">
                          <div className="feature-icon mr-3 text-white">
                            {feature.icon}
                          </div>
                          <span className={`transition-colors duration-300 ${
                            isDarkMode ? 'text-gray-300' : 'text-gray-700'
                          }`}>
                            {feature.name}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Ideal Uses */}
                  <div>
                    <h3 className={`text-lg font-semibold mb-4 transition-colors duration-300 ${
                      isDarkMode ? 'text-green-50' : 'text-gray-900'
                    }`}>
                      Cocok Untuk
                    </h3>
                    <div className="grid grid-cols-1 gap-2">
                      {selectedPackage.ideal.map((use, i) => (
                        <div key={i} className={`px-3 py-2 rounded-lg text-sm transition-colors duration-300 ${
                          isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-700'
                        }`}>
                          ✓ {use}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-6">
                  {/* Camera Specifications */}
                  <div>
                    <h3 className={`text-lg font-semibold mb-4 transition-colors duration-300 ${
                      isDarkMode ? 'text-green-50' : 'text-gray-900'
                    }`}>
                      Spesifikasi Kamera
                    </h3>
                    <div className="space-y-2">
                      {Object.entries(selectedPackage.cameras_detail).map(([spec, value], i) => (
                        <div key={i} className={`flex justify-between items-center px-3 py-2 rounded-lg transition-colors duration-300 ${
                          isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
                        }`}>
                          <span className={`transition-colors duration-300 ${
                            isDarkMode ? 'text-gray-300' : 'text-gray-700'
                          }`}>
                            {spec}
                          </span>
                          <span className="bg-green-600 text-white px-2 py-1 rounded-full text-sm font-bold">
                            {value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Technical Specs */}
                  <div>
                    <h3 className={`text-lg font-semibold mb-4 transition-colors duration-300 ${
                      isDarkMode ? 'text-green-50' : 'text-gray-900'
                    }`}>
                      Spesifikasi Teknis
                    </h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className={`transition-colors duration-300 ${
                          isDarkMode ? 'text-gray-400' : 'text-gray-600'
                        }`}>
                          Penyimpanan:
                        </span>
                        <span className={`font-semibold transition-colors duration-300 ${
                          isDarkMode ? 'text-green-50' : 'text-gray-900'
                        }`}>
                          {selectedPackage.storage}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className={`transition-colors duration-300 ${
                          isDarkMode ? 'text-gray-400' : 'text-gray-600'
                        }`}>
                          Support:
                        </span>
                        <span className={`font-semibold transition-colors duration-300 ${
                          isDarkMode ? 'text-green-50' : 'text-gray-900'
                        }`}>
                          {selectedPackage.support}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 mt-8">
                <button className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-semibold transition-colors">
                  Konsultasi Gratis
                </button>
                <button 
                  onClick={() => setSelectedPackage(null)}
                  className={`flex-1 border py-3 rounded-xl font-semibold transition-colors ${
                    isDarkMode 
                      ? 'border-gray-600 text-gray-300 hover:text-white hover:border-gray-500' 
                      : 'border-gray-300 text-gray-700 hover:text-gray-900 hover:border-gray-400'
                  }`}
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Benefits Section */}
      <section className={`py-16 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-900' : 'bg-white'
      }`}
      style={{ 
          backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0',
          backgroundBlendMode: 'overlay'
        }}

      >
        <div className="max-w-7xl mx-auto px-4"
        >
          <div className="text-center mb-12">
            <h2 className={`text-4xl font-bold mb-4 transition-colors duration-300 ${
              isDarkMode ? 'text-green-50' : 'text-gray-900'
            }`}
            >
              Keunggulan Sistem CCTV Kami
            </h2>
            <p className={`text-xl max-w-3xl mx-auto transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              Mengapa memilih sistem pengawasan dari kami untuk keamanan properti Anda
            </p>
          </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Professional Installation */}
       <div className="text-center">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="bg-gradient-to-br to-emerald-600 w-60 h-60 flex items-center justify-center mx-auto mb-4">
            <img src="image/CCTV/instalasipro.png" alt="Professional Installation" className="w-50 h-50" />
          </div>
          <h3 className={`text-lg font-bold mb-2 transition-colors duration-300 ${
            isDarkMode ? 'text-green-50' : 'text-gray-900'
          }`}>
            Instalasi Profesional
          </h3>
          <p className={`text-sm transition-colors duration-300 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            Tim ahli kami akan menginstal sistem CCTV dengan presisi untuk hasil terbaik
          </p>
        </div>
      </div>

        {/* Quality Products */}
        <div className="text-center">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="bg-gradient-to-br to-emerald-600 w-60 h-60 flex items-center justify-center mx-auto mb-4">
            <img src="image/CCTV/produkberkualitas.png" alt="Professional Installation" className="w-50 h-50" />
          </div>
          <h3 className={`text-lg font-bold mb-2 transition-colors duration-300 ${
            isDarkMode ? 'text-green-50' : 'text-gray-900'
          }`}>
            Produk Berkualitas
          </h3>
          <p className={`text-sm transition-colors duration-300 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            Kami hanya menggunakan kamera dan perangkat dari merek terpercaya
          </p>
        </div>
        </div>

        {/* 24/7 Support */}
        <div className="text-center">
        <div className="bg-white rounded-lg shadow-lg p-6">
           <div className="bg-gradient-to-br to-emerald-600 w-60 h-60 flex items-center justify-center mx-auto mb-4">
            <img src="image/CCTV/dukungan 24 jam.png" alt="Professional Installation" className="w-50 h-50" />
          </div>
          <h3 className={`text-lg font-bold mb-2 transition-colors duration-300 ${
            isDarkMode ? 'text-green-50' : 'text-gray-900'
          }`}>
            Dukungan 24/7
          </h3>
          <p className={`text-sm transition-colors duration-300 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            Tim support kami siap membantu Anda kapan saja dengan layanan 24/7.
          </p>
        </div>
        </div>

        {/* Easy Access */}
        <div className="text-center">
        <div className="bg-white rounded-lg shadow-lg p-6">
           <div className="bg-gradient-to-br to-emerald-600 w-60 h-60 flex items-center justify-center mx-auto mb-4">
            <img src="image/CCTV/aksesmudah.png" alt="Professional Installation" className="w-50 h-50" />
          </div>
          <h3 className={`text-lg font-bold mb-2 transition-colors duration-300 ${
            isDarkMode ? 'text-green-50' : 'text-gray-900'
          }`}>
            Akses Mudah
          </h3>
          <p className={`text-sm transition-colors duration-300 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            Pantau sistem CCTV Anda dari mana saja melalui aplikasi mobile atau web.
          </p>
        </div>
        </div>
        </div>
        </div>
      </section>

      {/* CTA Section */}
      <SecurityUpgradeSection /> 

      <Footer />
    </div>
  );
};

export default CCTVPage;